import React from 'react';
import { Activity } from 'lucide-react';

const PerformanceMonitor = () => {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-sm">
      <div className="p-6 border-b border-slate-700">
        <div className="flex items-center">
          <Activity className="w-6 h-6 text-blue-400 mr-3" />
          <div>
            <h2 className="text-xl font-semibold text-slate-200">Database Performance Monitor</h2>
            <p className="text-slate-400 mt-1">Monitor database performance metrics and optimization</p>
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="text-center py-12">
          <Activity className="w-16 h-16 text-slate-600 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-slate-300 mb-2">Database Performance Monitor</h3>
          <p className="text-slate-400">This page will contain database performance monitoring functionality.</p>
        </div>
      </div>
    </div>
  );
};

export default PerformanceMonitor;